import {createAction} from 'redux-act'

export const setTransferModalVisible = createAction('SET_TRANSFER_MODAL_VISIBLE')
export const setTransferForm = createAction('SET_TRANSFER_FORM')
export const closeTransferForm = createAction('CLOSE_TRANSFER_FORM')
export const transferFormSetTypes = createAction('TRANSFER_FORM_SET_TYPES')
export const setShowTopSelectType = createAction('SET_SHOW_TOP_SELECT_TYPE')



